<!-- <div class="col-xl-6" style="float: left;">

    <div class="kt-portlet kt-portlet--height-fluid">
        <div class="kt-portlet__body kt-portlet__body--fit">

            <div class="kt-widget kt-widget--project-1">
                <div class="kt-widget__head">
                    <div class="kt-widget__label">
                        <div class="kt-widget__media">
                            <span class="kt-media kt-media--lg kt-media--circle">
                                <img src="assets/img/foto3.JPG" alt="image">
                            </span>
                        </div>
                        <div class="kt-widget__info">
                            <a href="#" class="kt-widget__title">
                                FIRST Lego League
                            </a>
                            <span class="kt-widget__desc">
                                Online Turnuva
                            </span>
                        </div>
                    </div>
                </div>
                <div class="kt-widget__body">
                    <div class="kt-widget__stats">
                        <div class="kt-widget__item">
                            <span class="kt-widget__date">
                                Etkinlik Tarihi
                            </span>
                            <div class="kt-widget__label">
                                <span class="btn btn-label-brand btn-sm btn-bold btn-upper">1 Mart 2022</span>
                            </div>
                        </div>
                        <div class="kt-widget__item">
                            <span class="kt-widget__date">
                                Başvuru son tarih
                            </span>
                            <div class="kt-widget__label">
                                <span class="btn btn-label-danger btn-sm btn-bold btn-upper">25 Şubat 2022</span>
                            </div>
                        </div>
                        <div class="kt-widget__item flex-fill">
                            <span class="kt-widget__subtitel">Doluluk oranı</span>
                            <div class="kt-widget__progress d-flex  align-items-center">
                                <div class="progress" style="height: 5px;width: 100%;">
                                    <div class="progress-bar kt-bg-warning" role="progressbar" style="width: 78%;" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <span class="kt-widget__stat">
                                    78%
                                </span>
                            </div>
                        </div>
                    </div>
                    <span class="kt-widget__text">
                        FIRST Lego League online turnuvası için gönüllü başvurularımız açıldı!
                    </span>
                    <div class="kt-widget__content">
                        <div class="kt-widget__details">
                            <span class="kt-widget__subtitle">Kontenjan</span>
                            <span class="kt-widget__value">50</span>
                        </div>
                    </div>
                </div>
                <div class="kt-widget__footer">
                    <div class="kt-widget__wrapper">
                        <div class="kt-widget__section">
                            <div class="kt-widget__blog">
                                <i class="flaticon2-list-1"></i>
                                <a href="#" class="kt-widget__value kt-font-brand">2 Rozet</a>
                            </div>
                        </div>
                        <div class="kt-widget__section">
                            <button type="button" class="btn btn-success btn-sm btn-upper btn-bold">Başvur</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

</div>

<div class="col-xl-6" style="float: left;">

    <div class="kt-portlet kt-portlet--height-fluid">
        <div class="kt-portlet__body kt-portlet__body--fit">

            <div class="kt-widget kt-widget--project-1">
                <div class="kt-widget__head">
                    <div class="kt-widget__label">
                        <div class="kt-widget__media">
                            <span class="kt-media kt-media--lg kt-media--circle">
                                <img src="assets/img/foto1.jpg" alt="image">
                            </span>
                        </div>
                        <div class="kt-widget__info">
                            <a href="#" class="kt-widget__title">
                                World Robot Olimpiad
                            </a>
                            <span class="kt-widget__desc">
                                Online Turnuva
                            </span>
                        </div>
                    </div>
                </div>
                <div class="kt-widget__body">
                    <div class="kt-widget__stats">
                        <div class="kt-widget__item">
                            <span class="kt-widget__date">
                                Etkinlik Tarihi
                            </span>
                            <div class="kt-widget__label">
                                <span class="btn btn-label-brand btn-sm btn-bold btn-upper">4 Nisan 2022</span>
                            </div>
                        </div>
                        <div class="kt-widget__item">
                            <span class="kt-widget__date">
                                Başvuru son tarih
                            </span>
                            <div class="kt-widget__label">
                                <span class="btn btn-label-danger btn-sm btn-bold btn-upper">30 Mart 2022</span>
                            </div>
                        </div>
                        <div class="kt-widget__item flex-fill">
                            <span class="kt-widget__subtitel">Doluluk oranı</span>
                            <div class="kt-widget__progress d-flex  align-items-center">
                                <div class="progress" style="height: 5px;width: 100%;">
                                    <div class="progress-bar kt-bg-brand" role="progressbar" style="width: 11%;" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <span class="kt-widget__stat">
                                    11%
                                </span>
                            </div>
                        </div>
                    </div>
                    <span class="kt-widget__text">
                        World Robot Olimpiad online turnuvası için gönüllü başvurularımız açıldı!
                    </span>
                    <div class="kt-widget__content">
                        <div class="kt-widget__details">
                            <span class="kt-widget__subtitle">Kontenjan</span>
                            <span class="kt-widget__value">30</span>
                        </div>
                    </div>
                </div>
                <div class="kt-widget__footer">
                    <div class="kt-widget__wrapper">
                        <div class="kt-widget__section">
                            <div class="kt-widget__blog">
                                <i class="flaticon2-list-1"></i>
                                <a href="#" class="kt-widget__value kt-font-brand">1 Rozet</a>
                            </div>
                        </div>
                        <div class="kt-widget__section">
                            <button type="button" class="btn btn-success btn-sm btn-upper btn-bold">Başvur</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

</div> -->
<!-- <div class="col-lg-6" style="float: left;">

    <div class="kt-portlet kt-bg-primary kt-portlet--skin-solid kt-portlet--height-fluid">
        <div class="kt-portlet__head kt-portlet__head--noborder">
            <div class="kt-portlet__head-label">
                <h3 class="kt-portlet__head-title">
                    Duyurular
                </h3>
            </div>
        </div>
        <div class="kt-portlet__body">

            <div class="kt-widget7 kt-widget7--skin-light">
                <div class="kt-widget7__desc">
                    2022 yılı için alan gönüllüsü başvurularımız açıldı! Başvuruları çok geciktirmeyelim arkadaşlar, kotalar sınırlı.
                </div>
                <div class="kt-widget7__content">
                    <div class="kt-widget7__userpic">
                        <img src="assets/media//users/100_5.jpg" alt="">
                    </div>
                    <div class="kt-widget7__info">
                        <h3 class="kt-widget7__username">
                            Anıl Mehmet Şahin
                        </h3>
                        <span class="kt-widget7__time">
                            6 saat önce
                        </span>
                    </div>
                </div>
                <div class="kt-widget7__button">
                    <a class="btn btn-light" href="#" role="button">Bütün duyurular</a>
                </div>
            </div>

        </div>
    </div>

</div>
<div class="col-lg-6" style="float: left;">

    <div class="kt-portlet kt-bg-danger kt-portlet--skin-solid kt-portlet--height-fluid">
        <div class="kt-portlet__head kt-portlet__head--noborder">
            <div class="kt-portlet__head-label">
                <h3 class="kt-portlet__head-title">
                    Duyurular
                </h3>
            </div>
        </div>
        <div class="kt-portlet__body">

            <div class="kt-widget7 kt-widget7--skin-light">
                <div class="kt-widget7__desc">
                    2022 yılı için hakem başvurularımız açıldı! Lütfen başvurularımızı 28 Şubat'a kadar tamamlayalım.
                </div>
                <div class="kt-widget7__content">
                    <div class="kt-widget7__userpic">
                        <img src="assets/media//users/100_2.jpg" alt="">
                    </div>
                    <div class="kt-widget7__info">
                        <h3 class="kt-widget7__username">
                            İlkin Aydın
                        </h3>
                        <span class="kt-widget7__time">
                            2 gün önce
                        </span>
                    </div>
                </div>
                <div class="kt-widget7__button">
                    <a class="btn btn-brand" href="#" role="button">Bütün duyurular</a>
                </div>
            </div>

        </div>
    </div>

</div> -->
<div class="col-xl-12 col-lg-12 order-lg-1 order-xl-1" style="float: left;clear: both;">

    <div class="kt-portlet kt-portlet--height-fluid kt-widget19">
        <div class="kt-portlet__body kt-portlet__body--fit kt-portlet__body--unfill">
            <div class="kt-widget19__pic kt-portlet-fit--top kt-portlet-fit--sides" style="min-height: 300px; background-image: url(assets/img/announcement_cover.png)">
                <h3 class="kt-widget19__title kt-font-light">
                    Aramıza Hoş Geldin!
                </h3>
            </div>
        </div>
        <div class="kt-portlet__body">
            <div class="kt-widget19__wrapper">
                <div class="kt-widget19__content">
                    <div class="kt-widget19__userpic">
                        <img src="assets/img//bkd_logo_dark.png" alt="">
                    </div>
                    <div class="kt-widget19__info">
                        <a href="#" class="kt-widget19__username">
                            Dernek
                        </a>
                        <span class="kt-widget19__time">
                            Bilim Kahramanları Derneği
                        </span>
                    </div>
                </div>
                <div class="kt-widget19__text">
                    Sevgili Gönüllümüz, <br><br>
Bilim kahramanları ailesine hoş geldin! Bilimin ve bilimsel farkındalığın toplumun her kesime yayılması ve özellikle de çocuklar ve gençlerin daha erken yaşta bilimle buluşması hayalimize ortak olduğun için teşekkürler.
Platform üzerinde sağlayacağımız daha etkin iletişimle #umutbilimde diyerek yeni bir çalışmayı hayata geçireceğimiz inanıyoruz.
Yolculuğumuz yeni başlıyor!<br><br>
<strong>Bilim Kahramanları Derneği</strong>
                </div>
            </div>
        </div>
    </div>

</div>